const SESSION_NAME = "napcontable";
const SESSION_NAV = "navnc";
const SESSION_YEAR = "yearnc";

export { SESSION_NAME, SESSION_NAV, SESSION_YEAR };
